/* src/app/modules/portal/components/search-results-list/search-results-list.component.scss */
[flatMode] :host-context .recentSystem {
  padding: 0rem;
  padding-top: 1rem;
}
.recentSystem {
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}
.recent-searches-title {
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 8px;
}
sh-tabs {
  flex: 1 0;
}
.header {
  margin-bottom: 0.5rem;
}
.history {
  overflow-y: auto;
  position: relative;
  width: 100%;
}
.system.unsupported-system .unsupported {
  display: inline-block;
}
.unsupported {
  display: none;
  text-transform: uppercase;
  padding: 0.15rem 0.15rem;
  margin-left: 0.5rem;
  margin-right: 0.2rem;
  height: fit-content;
  line-height: 110%;
  border-radius: 2px;
  border: 0.8px solid rgba(0, 0, 0, 0.5);
}
.unsupported:empty {
  display: none;
}
.system:first-child {
  margin-top: 0rem;
}
.system:hover {
  cursor: pointer;
  background-color: rgba(var(--ui-1), var(--opacity-7)) !important;
}
.system sh-icon.time {
  grid-column-start: 1;
  grid-column-end: 1;
  grid-row-start: 1;
  grid-row-end: 1;
  margin: 0.25rem;
  margin-right: 0.5rem;
}
sh-icon.bookmark {
  grid-column-start: 1;
  grid-column-end: 1;
  grid-row-start: 1;
  grid-row-end: 3;
  align-items: start;
  margin-right: -0.5rem;
}
sh-icon.bookmark[bookmarked] {
  color: rgba(var(--ui-2), var(--opacity-1));
}
sh-icon.bookmark[aria-selected=true] {
  outline: var(--focus-outline);
}
.system-container {
  position: relative;
}
.system-container > sh-icon {
  top: 0.5rem;
}
.system-container sh-icon[aria-selected=true] {
  outline: var(--focus-outline);
}
.modality {
  text-transform: uppercase;
  background: rgba(var(--ui-1), 0.5);
  color: var(--base-0);
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  margin-right: 0.2rem;
  height: fit-content;
  display: inline-block;
  line-height: 110%;
  border-radius: 2px;
}
.modality:empty {
  display: none;
}
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.title {
  color: var(--text-secondary);
  align-items: center;
  font-size: 13px;
}
.system {
  font-family: "siemens sans";
  font-size: 14px;
}
.serial-number {
  align-items: center;
  font-weight: 600;
  font-size: 1rem;
  color: rgba(var(--ui-1), 1);
  display: flex;
}
.date {
  width: fit-content;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.title {
  display: flex;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.row1 {
  color: var(--text-secondary);
  opacity: 0.7;
}
[screen-desktop] :host-context .systems,
[screen-tablet] :host-context .systems,
[screen-desktop-large] :host-context .systems,
[screen-phone] :host-context .systems {
  display: flex;
  flex-direction: column;
  --gap: 0.4rem;
}
[screen-desktop] :host-context .systems .system,
[screen-tablet] :host-context .systems .system,
[screen-desktop-large] :host-context .systems .system,
[screen-phone] :host-context .systems .system {
  display: grid;
  column-gap: 1rem;
  grid-template-columns: 1fr 1fr;
  padding: 0.5rem;
  padding-left: 2rem;
  padding-bottom: 0.5rem;
  transition: var(--transition-time) all ease-in-out;
  background-color: rgba(var(--ui-1), 0);
  border-bottom: 1px solid rgba(var(--ui-1), var(--opacity-5));
}
[screen-desktop] :host-context .systems sh-icon,
[screen-tablet] :host-context .systems sh-icon,
[screen-desktop-large] :host-context .systems sh-icon,
[screen-phone] :host-context .systems sh-icon {
  position: absolute;
  left: 0px;
}
[screen-phone] :host-context .systems .system .title {
  grid-column: 1/3;
}
[screen-phone] :host-context .systems .system .title.row2 {
  margin-top: var(--gap-small);
}
[screen-phone] :host-context .systems .system .func-loc {
  grid-column: 1;
}
[screen-phone] :host-context .systems .system .func-loc.row1 {
  margin-top: var(--gap);
  grid-row: 3;
}
[screen-phone] :host-context .systems .system .func-loc.row2 {
  margin-top: var(--gap-small);
  grid-row: 4;
}
[screen-phone] :host-context .systems .system .mat-nr {
  grid-column: 2;
}
[screen-phone] :host-context .systems .system .mat-nr.row1 {
  margin-top: var(--gap);
  grid-row: 3;
}
[screen-phone] :host-context .systems .system .mat-nr.row2 {
  margin-top: var(--gap-small);
  grid-row: 4;
}
[screen-phone] :host-context .systems .system .costumer-name {
  grid-column: 1;
}
[screen-phone] :host-context .systems .system .costumer-name.row1 {
  margin-top: var(--gap);
  grid-row: 5;
}
[screen-phone] :host-context .systems .system .costumer-name.row2 {
  margin-top: var(--gap-small);
  grid-row: 6;
}
[screen-phone] :host-context .systems .system .costumer-city {
  grid-column: 2;
}
[screen-phone] :host-context .systems .system .costumer-city.row1 {
  margin-top: var(--gap);
  grid-row: 5;
}
[screen-phone] :host-context .systems .system .costumer-city.row2 {
  margin-top: var(--gap-small);
  grid-row: 6;
}
[screen-phone] :host-context .systems .system .equipment-tech-id {
  grid-column: 1;
}
[screen-phone] :host-context .systems .system .equipment-tech-id.row1 {
  margin-top: var(--gap);
  grid-row: 7;
}
[screen-phone] :host-context .systems .system .equipment-tech-id.row2 {
  margin-top: var(--gap-small);
  grid-row: 8;
}
[screen-phone] :host-context .systems .system .equipment-id {
  grid-column: 2;
}
[screen-phone] :host-context .systems .system .equipment-id.row1 {
  margin-top: var(--gap);
  grid-row: 7;
}
[screen-phone] :host-context .systems .system .equipment-id.row2 {
  margin-top: var(--gap-small);
  grid-row: 8;
}
[screen-tablet] :host-context .systems .system,
[screen-desktop] :host-context .systems .system {
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
[screen-tablet] :host-context .systems .system .title,
[screen-desktop] :host-context .systems .system .title {
  grid-column: 1;
}
[screen-tablet] :host-context .systems .system .title.row2,
[screen-desktop] :host-context .systems .system .title.row2 {
  margin-top: var(--gap-small);
}
[screen-tablet] :host-context .systems .system .func-loc,
[screen-desktop] :host-context .systems .system .func-loc {
  grid-column: 2;
}
[screen-tablet] :host-context .systems .system .func-loc.row1,
[screen-desktop] :host-context .systems .system .func-loc.row1 {
  margin-top: var(--gap);
  grid-row: 1;
}
[screen-tablet] :host-context .systems .system .func-loc.row2,
[screen-desktop] :host-context .systems .system .func-loc.row2 {
  margin-top: var(--gap-small);
  grid-row: 2;
}
[screen-tablet] :host-context .systems .system .mat-nr,
[screen-desktop] :host-context .systems .system .mat-nr {
  grid-column: 3;
}
[screen-tablet] :host-context .systems .system .mat-nr.row1,
[screen-desktop] :host-context .systems .system .mat-nr.row1 {
  margin-top: var(--gap);
  grid-row: 1;
}
[screen-tablet] :host-context .systems .system .mat-nr.row2,
[screen-desktop] :host-context .systems .system .mat-nr.row2 {
  margin-top: var(--gap-small);
  grid-row: 2;
}
[screen-tablet] :host-context .systems .system .costumer-name,
[screen-desktop] :host-context .systems .system .costumer-name {
  grid-column: 4;
}
[screen-tablet] :host-context .systems .system .costumer-name.row1,
[screen-desktop] :host-context .systems .system .costumer-name.row1 {
  margin-top: var(--gap);
  grid-row: 1;
}
[screen-tablet] :host-context .systems .system .costumer-name.row2,
[screen-desktop] :host-context .systems .system .costumer-name.row2 {
  margin-top: var(--gap-small);
  grid-row: 2;
}
[screen-tablet] :host-context .systems .system .costumer-city,
[screen-desktop] :host-context .systems .system .costumer-city {
  grid-column: 2;
}
[screen-tablet] :host-context .systems .system .costumer-city.row1,
[screen-desktop] :host-context .systems .system .costumer-city.row1 {
  margin-top: var(--gap);
  grid-row: 3;
}
[screen-tablet] :host-context .systems .system .costumer-city.row2,
[screen-desktop] :host-context .systems .system .costumer-city.row2 {
  margin-top: var(--gap-small);
  grid-row: 4;
}
[screen-tablet] :host-context .systems .system .equipment-tech-id,
[screen-desktop] :host-context .systems .system .equipment-tech-id {
  grid-column: 3;
}
[screen-tablet] :host-context .systems .system .equipment-tech-id.row1,
[screen-desktop] :host-context .systems .system .equipment-tech-id.row1 {
  margin-top: var(--gap);
  grid-row: 3;
}
[screen-tablet] :host-context .systems .system .equipment-tech-id.row2,
[screen-desktop] :host-context .systems .system .equipment-tech-id.row2 {
  margin-top: var(--gap-small);
  grid-row: 4;
}
[screen-tablet] :host-context .systems .system .equipment-id,
[screen-desktop] :host-context .systems .system .equipment-id {
  grid-column: 4;
}
[screen-tablet] :host-context .systems .system .equipment-id.row1,
[screen-desktop] :host-context .systems .system .equipment-id.row1 {
  margin-top: var(--gap);
  grid-row: 3;
}
[screen-tablet] :host-context .systems .system .equipment-id.row2,
[screen-desktop] :host-context .systems .system .equipment-id.row2 {
  margin-top: var(--gap-small);
  grid-row: 4;
}
[screen-desktop-large] :host-context .systems .system {
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr 1fr;
}
[screen-desktop-large] :host-context .systems .system .title {
  grid-column: 1;
}
[screen-desktop-large] :host-context .systems .system .title.row2 {
  margin-top: var(--gap-small);
}
[screen-desktop-large] :host-context .systems .system .func-loc {
  grid-column: 2;
}
[screen-desktop-large] :host-context .systems .system .func-loc.row1 {
  margin-top: var(--gap);
  grid-row: 1;
}
[screen-desktop-large] :host-context .systems .system .func-loc.row2 {
  margin-top: var(--gap-small);
  grid-row: 2;
}
[screen-desktop-large] :host-context .systems .system .mat-nr {
  grid-column: 3;
}
[screen-desktop-large] :host-context .systems .system .mat-nr.row1 {
  margin-top: var(--gap);
  grid-row: 1;
}
[screen-desktop-large] :host-context .systems .system .mat-nr.row2 {
  margin-top: var(--gap-small);
  grid-row: 2;
}
[screen-desktop-large] :host-context .systems .system .costumer-name {
  grid-column: 4;
}
[screen-desktop-large] :host-context .systems .system .costumer-name.row1 {
  margin-top: var(--gap);
  grid-row: 1;
}
[screen-desktop-large] :host-context .systems .system .costumer-name.row2 {
  margin-top: var(--gap-small);
  grid-row: 2;
}
[screen-desktop-large] :host-context .systems .system .costumer-city {
  grid-column: 5;
}
[screen-desktop-large] :host-context .systems .system .costumer-city.row1 {
  margin-top: var(--gap);
  grid-row: 1;
}
[screen-desktop-large] :host-context .systems .system .costumer-city.row2 {
  margin-top: var(--gap-small);
  grid-row: 2;
}
[screen-desktop-large] :host-context .systems .system .equipment-tech-id {
  grid-column: 6;
}
[screen-desktop-large] :host-context .systems .system .equipment-tech-id.row1 {
  margin-top: var(--gap);
  grid-row: 1;
}
[screen-desktop-large] :host-context .systems .system .equipment-tech-id.row2 {
  margin-top: var(--gap-small);
  grid-row: 2;
}
[screen-desktop-large] :host-context .systems .system .equipment-id {
  grid-column: 7;
}
[screen-desktop-large] :host-context .systems .system .equipment-id.row1 {
  margin-top: var(--gap);
  grid-row: 1;
}
[screen-desktop-large] :host-context .systems .system .equipment-id.row2 {
  margin-top: var(--gap-small);
  grid-row: 2;
}
.no-recent-systems {
  align-items: center;
  text-align: center;
  color: var(--text-secondary);
  font-style: italic;
  justify-content: center;
  display: flex;
}
.system[aria-selected=true] {
  background-color: rgba(var(--ui-1), var(--opacity-7)) !important;
  outline: var(--focus-outline);
  outline-offset: -2px;
}
.content {
  flex-direction: row;
  align-items: center;
}
[screen-tablet] :host-context .systems,
[screen-phone] :host-context .systems {
  max-height: 80%;
}
[screen-tablet] :host-context .advanced-search-btn,
[screen-phone] :host-context .advanced-search-btn {
  display: inline-flex;
}
[screen-tablet] :host-context .advanced-search-content,
[screen-phone] :host-context .advanced-search-content {
  display: inline-flex;
}
[screen-tablet] :host-context .advance-search-text,
[screen-phone] :host-context .advance-search-text {
  display: inline-flex;
}
.advanced-search-btn {
  align-content: center;
  display: none;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 8px 115px;
  margin-top: 20px;
  border-radius: 80px;
  background-color: #e9e9e9;
  cursor: pointer;
}
.advanced-search-content {
  display: none;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0 auto;
}
.advance-search-text {
  font-weight: 600;
  display: none;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: nowrap;
}
/*# sourceMappingURL=search-results-list.component.css.map */
